import { memo, useMemo } from 'react'
import { useWireValue } from '@forminator/react-wire'
import ConveyanceDocCol from './ConveyanceDocCol'
import { isEqual } from '@/utils'
import * as store from '@store'
import randomColor from 'randomcolor'

const arePropsEqual = (prev, curr) => {
    if (Object.is(prev, curr)) return true
    const prevConveyances = prev.party.conveyances.find(c => c.documentId === prev.documentId) || {}
    const currConveyances = curr.party.conveyances.find(c => c.documentId === curr.documentId) || {}
    
    return isEqual(prevConveyances, currConveyances)
}

const ConveyanceDocRow = memo(({
    x,
    documentId,
    party,
    conveyanceType,
    getLastInteractionRef,
    chainHeaders,
}) => {
    
    const titlePartyGroups = useWireValue(store.titlePartyGroups)
    const conveyances = party.conveyances.find(c => c.documentId === documentId) || {}
    const groupsMap = titlePartyGroups[documentId] || {}
    const groupId = Object.keys(groupsMap).find(k => Object.hasOwn(groupsMap[k], party.id))
    const group = groupsMap[groupId] || {}
    const groupKeys = Object.keys(group)
    const groupSize = groupKeys.length
    
    const groupColor = useMemo(() => {
        if (!Object.keys(group).length) return null
        return group.color || randomColor()
    }, [group])
    
    return (
        <tr style={{ '--group-color': groupColor }}
            data-party-type={conveyances.partyType}
            data-group-id={groupId}
            data-group-size={groupSize}
            data-group-idx={group[party.id]}>
            {chainHeaders.map((type, idx) => <ConveyanceDocCol
                key={`${documentId}-${party.id}-doc-conv-${type}`}
                x={x}
                y={idx}
                type={type}
                documentId={documentId}
                party={party}
                partyType={conveyances.partyType}
                conveyanceType={conveyanceType}
                conveyance={conveyances[type] || {}}
                getLastInteractionRef={getLastInteractionRef}
                onInteractionComplete={() => {
                    const lastInteractionRef = getLastInteractionRef()
                    
                    if (lastInteractionRef?.current)
                        lastInteractionRef.current = null
                }} />)}
        </tr>
    )
}, arePropsEqual)

ConveyanceDocRow.displayName = 'ConveyanceDocRow'

export default ConveyanceDocRow
